export interface ControlBarToolbarInput {
	showSaveButton: boolean;
	isEditMode: boolean;
	treeId?: string;
	isLoading: boolean;
	canEdit: boolean;
	hasUser: boolean;
	hasSaveHandler: boolean;
	hasDeployHandler?: boolean;
}

export interface ControlBarToolbarState {
	showSaveButton: boolean;
	showPreviewEditToggle: boolean;
	previewEditLabel: 'Preview' | 'Edit';
	showDeployButton: boolean;
}

/**
 * Pure logic for the tree editor control bar's wide toolbar: which actions to show
 * and the preview/edit button label. The DRAFT/undo/redo cluster is not decided
 * here — TreeEdit builds and gates it once and passes it via the control bar's
 * editStatus slot (dev panel bar on narrow viewports), so wide and narrow layouts
 * cannot disagree.
 */
export class ControlBarInteractor {
	/** Computes visibility of publish and the preview/edit toggle from auth, loading, and edit flags. */
	getToolbarState(input: ControlBarToolbarInput): ControlBarToolbarState {
		const { isLoading } = input;
		return {
			showSaveButton: !isLoading && input.showSaveButton && input.hasSaveHandler,
			showPreviewEditToggle:
				!isLoading && input.hasUser && Boolean(input.treeId) && input.canEdit,
			previewEditLabel: input.isEditMode ? 'Preview' : 'Edit',
			// Deploy belongs to the edit page only: anyone who got here can export, but
			// the action makes no sense on the public view or before the tree loads.
			showDeployButton:
				!isLoading &&
				input.isEditMode &&
				input.canEdit &&
				Boolean(input.treeId) &&
				input.hasDeployHandler === true,
		};
	}
}
